export const POST_SIGN_IN_REDIRECT_URL = '/quality-control/';
export const ROUTE = '/accounts/auth';
